module.exports = __webpack_public_path__ + "static/media/check-radio.7139df4a.svg";